import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import { memo, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import {
  $isComponentsLoaded,
  loadMoreCurrentComponents as moduleLoadMoreCurrentComponents,
} from '../../model/components/dynamic-components'

export const LoadMoreComponentsTrigger = memo(LoadMoreComponentsTrigger_)

LoadMoreComponentsTrigger_.displayName = 'LoadMoreComponentsTrigger'
function LoadMoreComponentsTrigger_(): JSX.Element {
  const [isLoaded, loadMoreCurrentComponents] = useUnit([
    $isComponentsLoaded,
    moduleLoadMoreCurrentComponents,
  ])

  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && !isLoaded) {
      loadMoreCurrentComponents()
    }
  }, [inView, isLoaded, loadMoreCurrentComponents])

  return <div ref={ref} style={{ minHeight: 1 }} />
}
